import { imageStore } from '../images.js';
import Boundary from './Boundary.js';
import Sprite from '../ui/Sprite.js';

export default class BattleZone extends Boundary {
    serialize() {
        console.log(`Serializing ${this.constructor.name}`);
        return {
            position: this.position,
            visible: this.visible,
            encounterRate: this.encounterRate,
        };
    }

    static deserialize(data) {
        return new BattleZone({
            position: data.position,
            visible: data.visible,
            encounterRate: data.encounterRate,
        });
    }

    constructor({ position, visible = true, encounterRate = 0.1, encounterType = 'land' }) {
        super({ position });
        this.encounterRate = encounterRate;
        this.visible = visible;
        this.drawAbovePlayer = true;
        this.encounterType = encounterType;

        this.grass = new Sprite({
            position: this.position,
            image: imageStore.get('img/grass_animation_v2.png'),
            frames: { max: 5, stopAtEnd: false },
            moving: false,
            visible: true,
            hold: 8,
        });
    }

    ruffleGrass() {
        if (!this.visible) {
            return;
        }
        this.grass.visible = true;
        if (!this.grass.moving) {
            this.grass.frames.val = 1;
        }
        this.grass.moving = true;
    }

    draw() {
        this.grass.position = this.effectivePosition();
        if (!this.visible) {
            return;
        }
        this.grass.draw();
        if (this.grass.frames.val === 4) {
            this.grass.moving = false;
            this.grass.frames.val = 0;
        }
    }
}
